const r = "SEPARATOR1",
  u = "SEPARATOR2",
  A = function (t) {
    let o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return Array.from({
      length: t
    }, (c, s) => s + o);
  };
function m(t, o, c) {
  if (o <= c) return A(o);
  const s = 1,
    h = c - 3,
    f = h / 2;
  if (t - s < f || o - t < f) {
    const i = A(f + s, 1),
      e = A(f + 1, o - f);
    return [...i, r, ...e];
  } else if (t - s >= h && o - t >= h) {
    const i = f - 1,
      e = A(h - 1, t - i);
    return [1, r, ...e, u, o];
  } else {
    const i = [],
      e = t - s < o - t;
    let d = c;
    if (e) {
      for (let n = 1; n <= t + 1; n++) i.push(n), d -= 1;
      i.push(r), d -= 1;
      for (let n = o - (d - 1); n <= o; n++) i.push(n);
    } else {
      for (let n = o; n >= t - 1; n--) i.unshift(n), d -= 1;
      i.unshift(r), d -= 1;
      for (let n = d; n >= 1; n--) i.unshift(n);
    }
    return i;
  }
}
export { r as SEPARATOR1, u as SEPARATOR2, m as getPaginationItems };